// ISD report links. An intersection is analysed once per MANEUVER (leg + AASHTO case),
// and every maneuver has its own quality and its own online report page. So "the ISD
// report" of an intersection is ambiguous: these helpers offer one link per maneuver
// whose sight distance is short of the required distance, worst first, each labelled
// with the quality the reader will find on that page.
import React from 'react';

export const pct = (q) => (q == null ? '—' : `${Math.round(q * 100)}%`);

/** Maneuvers below 100%, worst first (the server already sorts; this is defensive). */
export const shortManeuvers = (maneuvers) => (maneuvers || [])
  .filter((m) => typeof m.quality === 'number' && m.quality < 1)
  .sort((a, b) => a.quality - b.quality);

/** Popup buttons: one per short maneuver; falls back to the single report link. */
export function ManeuverButtons({ maneuvers, fallbackUrl, fallbackLabel }) {
  const short = shortManeuvers(maneuvers).filter((m) => m.reportUrl);
  if (!short.length) {
    return fallbackUrl ? (
      <a className="safety-btn safety-report-btn" href={fallbackUrl} target="_blank" rel="noreferrer">{fallbackLabel} ↗</a>
    ) : null;
  }
  return (
    <>
      {short.map((m) => (
        <a key={m.id} className="safety-btn safety-report-btn" href={m.reportUrl} target="_blank" rel="noreferrer"
          title={`${m.id} · ${m.label || ''}`}>
          Open ISD report · {m.name} · {pct(m.quality)} ↗
        </a>
      ))}
    </>
  );
}

/** Popup table rows: every maneuver with its quality (short ones highlighted). */
export function ManeuverRows({ maneuvers }) {
  if (!(maneuvers || []).length) return null;
  return (
    <>
      {maneuvers.map((m) => (
        <tr key={m.id} title={m.id}>
          <td>{m.name}</td>
          <td>
            <span className={typeof m.quality === 'number' && m.quality < 1 ? 'safety-maneuver-short' : ''}>{pct(m.quality)}</span>
            {m.label ? <span className="safety-maneuver-label"> · {m.label}</span> : null}
          </td>
        </tr>
      ))}
    </>
  );
}
